export const filterOptions = [
  {
    labels: "Campaign Name",
    value: false,
  },
  {
    labels: "Campaign Owner",
    value: false,
  },
  // {
  //   labels: "Converted Contact",
  //   value: false,
  // },
  // {
  //   labels: "Converted Account",
  //   value: false,
  // },
  // {
  //   labels: "Converted Deal",
  //   value: false,
  // },
  {
    labels: "Created By",
    value: false,
  },
  {
    labels: "Created Time",
    value: false,
  },
  {
    labels: "Start Date",
    value: false,
  },
  {
    labels: "End Date",
    value: false,
  },
  // {
  //   labels: "Email Opt Out",
  //   value: false,
  // },
   {
    labels: "Actual Cost",
    value: false,
  },
  {
    labels: "Budgeted Cost",
    value: false,
  },
  {
    labels: "Expected Revenue",
    value: false,
  },
  {
    labels: "Expected Response",
    value: false,
  },
  {
    labels: "Status",
    value: false,
  },
  {
    labels: "Type",
    value: false,
  }
];
  export const CREATED_TIME_OPTIONS = [
    { label: "Today", value: "Today" },
    { label: "Yesterday", value: "Yesterday" },
    { label: "This Week", value: "This Week" },
    { label: "This Month", value: "This Month" },
    { label: "Last Week", value: "Last Week" },
    { label: "Last Month", value: "Last Month" },
    { label: "Custom", value: "Custom" },
  ];

  
  export const actionsOptions = [
    { value: "Archive", id: 1 },
    { value: "Update", id: 2 },
    { value: "Export Campaigns", id: 3 },
  ];
  
export const campaignEditableFields = [
  { label: "Actual Cost", id: 1, value: "actualCost" },
  { label: "Budgeted Cost", id: 2, value: "budgetedCost" },
  { label: "Campaign Owner", id: 3, value: "campaignOwner" },
  { label: "Description", id: 4, value: "description" },
  { label: "Expected Response", id: 5, value: "expectedResponse" },
  { label: "Expected Revenue", id: 6, value: "expectedRevenue" },
  { label: "Status", id: 7, value: "status" },
  { label: "Type", id: 8, value: "type" },
  { label: "Start And End Date", id: 8, value: "startAndEndDate" },
];


  